import type { JsExceptionRecordDto } from '@zg-rentals/ts-dragnet-client/types/dragnet/JsExceptionRecordDto';
import type { PublishingResponseDto } from '@zg-rentals/ts-dragnet-client/types/instrumentation/PublishingResponseDto';
import { Dragnet } from '@zg-rentals/dragnet-base';
import { DragnetJsBrowserCollectionHandler_browserExceptions } from '@zg-rentals/ts-dragnet-client/webapp-client/dragnet/DragnetJsBrowserCollectionHandler';
import { createClient } from '@zg-rentals/ts-dragnet-client/client';
import { getEnvironmentOverride, injectAppNameHeader, isDev } from '@zg-rentals/environment-utils';
import { getGlobalLogger } from '@zg-rentals/logger-browser';

function getShortUserAgent() {
  if (typeof navigator === 'undefined') return 'server';

  const userAgent = navigator.userAgent;
  let browser, os;

  // Detect browser
  if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox';
  } else if (userAgent.indexOf('SamsungBrowser') > -1) {
    browser = 'Samsung Internet';
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    browser = 'Opera';
  } else if (userAgent.indexOf('Trident') > -1) {
    browser = 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    browser = 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browser = 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    browser = 'Safari';
  } else {
    browser = 'Unknown Browser';
  }

  // Detect OS
  if (userAgent.indexOf('Win') > -1) {
    os = 'Windows';
  } else if (userAgent.indexOf('Mac') > -1) {
    os = 'MacOS';
  } else if (userAgent.indexOf('X11') > -1) {
    os = 'UNIX';
  } else if (userAgent.indexOf('Linux') > -1) {
    os = 'Linux';
  } else if (userAgent.indexOf('Android') > -1) {
    os = 'Android';
  } else if (userAgent.indexOf('like Mac') > -1) {
    os = 'iOS';
  } else {
    os = 'Unknown OS';
  }

  return `${browser}_on_${os}`.replace(/\s+/g, '_').toLowerCase();
}

export class DragnetBrowser extends Dragnet {
  constructor(appName: string, buildVersion: number) {
    super(appName, buildVersion, getShortUserAgent(), 50);
  }

  protected async request(batch: Array<JsExceptionRecordDto>): Promise<PublishingResponseDto> {
    if (isDev()) {
      return { success: true, message: 'skipped due to dev mode' };
    }

    try {
      const client = createClient({
        prefixUrl: 'https://dragnet.hotpads.com',
        headers: {
          ...injectAppNameHeader({}, this.appName),
        },
        keepalive: true,
      });

      return await DragnetJsBrowserCollectionHandler_browserExceptions(
        {
          environment: getEnvironmentOverride().unwrapOr('production'),
          records: batch,
        },
        client,
      );
    } catch (err) {
      getGlobalLogger('dragnetBrowser')?.error(
        {
          errMessage: err.message,
          errStack: err.stack,
        },
        'error making post request',
      );
    }
    return { success: false, message: 'error making post request' };
  }
}
